import CodeTimeOfDayList from './pages/ListPage.vue'
import CodeTimeOfDayDetail from './pages/FormPage.vue'
import CodeTimeOfDayIndex from './pages/IndexPage.vue'

export default [
  {
    path: '/code_time_of_day',
    component: CodeTimeOfDayIndex,
    redirect: '/code_time_of_day/list',
    name: 'code_time_of_day',
    children: [
      {
        path: 'list',
        component: CodeTimeOfDayList,
        name: 'code_time_of_day.list'
      },
      {
        path: 'create',
        component: CodeTimeOfDayDetail,
        name: 'code_time_of_day.create',
        props: {create: true},
      },
      {
        path: 'edit/:id',
        component: CodeTimeOfDayDetail,
        name: 'code_time_of_day.edit',
        props: {create: false},
      },
    ],
  },
]
